var map = {
	"./Logo_Sentbiz_white_01.png": "69da",
	"./Logo_Sentbiz_white_02.png": "d949",
	"./btn-info.svg": "f1ed",
	"./btn-listdropdown-down.svg": "a427",
	"./country/kr.svg": "d927",
	"./damir.jpg": "34e4",
	"./floating-button-1.svg": "5bd9",
	"./floating-button-2.svg": "b418",
	"./globe-network-1294.svg": "bc9d",
	"./ico-filter.svg": "80b0",
	"./icon-logout.svg": "51a8",
	"./icons/ico-calendar.svg": "0913",
	"./icons/ico-graph.svg": "0a1b",
	"./img-txtsentbe.svg": "be65",
	"./img-txtsentbiz.svg": "a65b",
	"./img_web_main.jpg": "dbe7",
	"./left-arrow.svg": "947f",
	"./login_bg.png": "963d",
	"./nav/ico-history-off-copy.svg": "84c9",
	"./nav/ico-home-on-copy.svg": "f089",
	"./nav/ico-recipient-off-copy.svg": "ded5",
	"./nav/ico-sendmoney-off-copy.svg": "0a11",
	"./nav/ico_dome_on.svg": "61a6",
	"./partners/DBS.png": "8bbd",
	"./partners/MDAQ.png": "32c7",
	"./partners/SCB.png": "5018",
	"./partners/bri.png": "d5f9",
	"./partners/coinph.png": "cb8a",
	"./partners/deemoney.png": "e56f",
	"./partners/kebhana.png": "3231",
	"./partners/koreainvestment.png": "b98e",
	"./partners/metrobank.png": "2d6c",
	"./partners/moneygram.png": "c80b",
	"./partners/moneymatch.png": "e3b7",
	"./partners/nium.png": "640c",
	"./partners/rapyd.png": "2f4b",
	"./partners/remitly.png": "e5ce",
	"./partners/ripple.png": "8a7d",
	"./partners/shinhan.png": "5fc0",
	"./partners/snmsung-pay.png": "0de5",
	"./partners/thunes.png": "133e",
	"./partners/tranglo.png": "74a5",
	"./partners/vietcombank.png": "1141",
	"./partners/wallex.png": "4255",
	"./partners/welcomebank.png": "46e1",
	"./partners/wyre.png": "98db",
	"./partners/xendit.png": "f7fb",
	"./patrick-tomasso-gMes5dNykus-unsplash.jpg": "b027",
	"./recipient/ico-check-person.svg": "3b4e",
	"./recipient/ico-excel-black.svg": "d2bb4",
	"./recipient/ico-excel-blue.svg": "f082",
	"./recipient/ico-recipient-download.svg": "a363",
	"./recipient/img-recipient-man.png": "e315",
	"./right-arrow.svg": "1df7",
	"./wallet/arrow-left-363.svg": "5ce4",
	"./wallet/arrow-right-363.svg": "28ed",
	"./wallet/ico-walletlist-remittance.svg": "a7b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";